import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ELocalStorage } from '../enums/ELocalStorage';
import { EModelApiPaths } from '../enums/EModelApiPaths';
import { EUserType } from '../enums/EUserType';
import { EHeader, IAPIResponse, IDecryptDataFETransfer, IDecryptDataFETransferPayload } from '../enums/types';
import { IUser } from '../interfaces/IUser';
import { UtilsService } from './utils.service';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    // @ts-ignore
    gUser: IUser;
    token = {
        accessToken: '',
        refreshToken: '',
    };
    userToken = "";

    constructor(private httpClient: HttpClient,
        public router: Router,
        public utilsService: UtilsService,) {
    }

    setUserToLocalStorage(userObj: IUser, p: string) {
        this.gUser = userObj;
        this.gUser.accessToken = this.token.accessToken;
        this.gUser.refreshToken = this.token.refreshToken;
        const encryptedCode = this.utilsService.getEncryptedString(this.gUser, p);
        (<any>window).localStorage.setItem(ELocalStorage.USER, encryptedCode);
    }


    getUserFromLocalStorage(p: string) {
        const value = (<any>window).localStorage.getItem(ELocalStorage.USER);
        if (value) {
            const decryptedObj = this.utilsService.getDecryptedObject(value, p);
            if (decryptedObj) return decryptedObj;
            else (<any>window).localStorage.setItem(ELocalStorage.USER, '');
        }
    }

    getUserId() {
        const tempUser: IUser = <any>this.gUser; // IAmCloudUser also supported
        if (!tempUser) {
            this.logout();
            window.location.reload();
        }

        if (tempUser.usr_type_str === EUserType.CUSTOMER) {
            return tempUser._id;
        } else throw "Invalid User ID";
    }

    isTokenExpired(token: string): boolean {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.exp * 1000 < Date.now();
        } catch {
            return false;
        }
    }

    clearLocalStorage() {
        localStorage.clear();
        this.gUser = <any>undefined;
        this.token.accessToken = '';
        this.token.refreshToken = '';
    }

    async logout() {
        this.clearLocalStorage();
        let defaultAMToken: any = await this.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);
        await this.router.navigate(['/']);
    }

    async getAMToken() {
        const encryptedPayload = this.utilsService.getEncryptedString(<IDecryptDataFETransferPayload>{
            data: this.utilsService.authTokenAM,
            createdAt: new Date(),
        }, environment.crypto.passJWT);
        const res: IAPIResponse<IUser> = <any>await this.httpClient.post(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.SYSTEM_API_BASE + `/${environment.USER_PATH}/token`,
            <IDecryptDataFETransfer>{ dataEncFE: encryptedPayload }, {
            headers: {
                [EHeader.ENCRYPTED_PAYLOAD]: 'true',
            },
        }).toPromise();
        return res.data;
    }

}
